/* sb-dc-nosafe.js — turn the safe area off, and stop calling the finishing
   inset a "safe area".

   Two things carried the safe area, and both have to go or the customer sees
   half of it:
     __dcShowSafe  the magenta dashed rectangle and the "Safe area" pill
     __dcBaseSafe  the 1" inset itself, which is what the preflight measures
                   against

   Turning off only the first would hide the line while still blocking orders
   for crossing a line nobody can see — worse than leaving it on.

   What remains after that is the FINISHING inset: with hem + grommets the
   outer 2" really is folded and punched, so artwork out there really does
   disappear. That warning stays — but its wording still said "outside the
   safe area", naming a thing we just removed. Reworded below to say what
   actually happens to the print.

   Both hooks are defined in the augment bundle; this file loads after it and
   overrides them, so the 322KB bundle does not need re-uploading. */
(function () {
  'use strict';

  window.__dcShowSafe = function () { return false; };   // no dashed rect, no pill
  window.__dcBaseSafe = function () { return 0; };       // safe rect == finishing only

  /* Reword in place. The preflight builds its issues in the bundle and then
     hands the array to __dcClipIssues for the patch layers to add to — which
     means we also get to edit what is already in it. */
  var prev = window.__dcClipIssues;
  window.__dcClipIssues = function (layers, issues) {
    if (typeof prev === 'function') { try { prev(layers, issues); } catch (e) {} }
    try {
      if (!Array.isArray(issues)) return;
      issues.forEach(function (it) {
        if (!it || typeof it.title !== 'string') return;
        if (it.title.indexOf('outside the safe area') >= 0) {
          it.title = it.title.replace('is outside the safe area',
                                      'reaches into the finishing edge');
          it.detail = 'The hem, grommets and pole pockets take the outer edge, '
            + 'so anything out there gets folded, sewn or hidden inside a pocket.';
          it.fix = 'Move it further in from the edge.';
        }
        if (it.title.indexOf('curves outside the safe area') >= 0) {
          it.title = it.title.replace('curves outside the safe area',
                                      'curves into the finishing edge');
          it.fix = 'Reduce the curve or move the box further in.';
        }
      });
    } catch (e) {}
  };

  /* The bundle memoises geometry and preflight per spec object, so a board
     that was already measured with the old 1" inset keeps its stale warnings.
     Rewriting the spec with the same values forces one recalculation.
     false = no undo step. */
  var done = false, tries = 0;
  var t = setInterval(function () {
    if (done || ++tries > 60) { clearInterval(t); return; }
    var a = window.__dcApi, s = a && a.spec;
    if (!a || !s || typeof a.setSpec !== 'function') return;
    done = true;
    clearInterval(t);
    try {
      a.setSpec({ widthIn: s.widthIn, heightIn: s.heightIn, finishing: s.finishing,
                  quantity: s.quantity, material: s.material, __dcProd: s.__dcProd }, false);
    } catch (e) {}
  }, 200);
})();
